import { createApi } from "@reduxjs/toolkit/query/react";
import { api } from "../../../api/Api.jsx";

export const StudentExit = createApi({
    reducerPath: 'StudentsExit',
    baseQuery: api,  
    tagTypes: ['StudentsExit'],
    endpoints: (build) => ({
        getStudentExit: build.query({
            query: (body) => `https://alcrm.pythonanywhere.com/api/v1/students/get_deleted_students/?deleted_log=true&author=true`,
            providesTags: ['tagTypes'],

        }),
        getStudents: build.query({
            query: () => "students/get_deleted_students/?deleted_log=true&author=true",
            providesTags: ['Students'],
        }),
    }),
});

export const {
    useGetStudentExitQuery,

} = StudentExit;